import { Grid, styled } from "@mui/material";
import { info } from "../../common/Theme/theme";

const BUYER_PROFILE_DETAILS_PREFIX = "BuyerProfileDetails";

export const buyerProfileClasses = {
    root: `${BUYER_PROFILE_DETAILS_PREFIX}-root`,
    userPropertiesContainer: `${BUYER_PROFILE_DETAILS_PREFIX}-userPropertiesContainer`,
    profilePicture: `${BUYER_PROFILE_DETAILS_PREFIX}-profilePicture`,
    welcome: `${BUYER_PROFILE_DETAILS_PREFIX}-welcome`,
    userPropertiesButtons: `${BUYER_PROFILE_DETAILS_PREFIX}-userPropertiesButtons`,
    userPropertiesFavoritesButton: `${BUYER_PROFILE_DETAILS_PREFIX}-userPropertiesFavoritesButton`,
    userPropertiesEmail: `${BUYER_PROFILE_DETAILS_PREFIX}-userPropertiesEmail`,
};

export const StyledBuyerProfile = styled(Grid)(({ theme }) => ({
    [`&.${buyerProfileClasses.root}`]: {
        backgroundColor: "#F8F8F8",
        [theme.breakpoints.up("md")]: {
            width: "100%",
            padding: "100px 100px",
        },
        [theme.breakpoints.down("md")]: {
            maxWidth: "100%",
            width: "100%",
            minHeight: "100vh",
            alignItems: "center",
        },
    },
    [`& .${buyerProfileClasses.userPropertiesContainer}`]: {
        backgroundColor: theme.palette.common.white,
        padding: "10px 10px",
        borderRadius: "8px",
        margin: "auto",
        marginTop: "30px",
        marginBottom: "30px",
        [theme.breakpoints.only("xs")]: {
            marginTop: "70px",
        },
    },
    [`& .${buyerProfileClasses.profilePicture}`]: {
        margin: "0 30px",
        width: "80px",
        height: "80px",
    },
    [`& .${buyerProfileClasses.welcome}`]: {
        margin: "0 30px",
    },
    [`& .${buyerProfileClasses.userPropertiesButtons}`]: {
        textTransform: "capitalize",
        color: theme.palette.common.black,
        backgroundColor: "#FAFAFA",
        borderRadius: "100px",
        width: "300px",
        marginTop: "20px",
    },
    [`& .${buyerProfileClasses.userPropertiesFavoritesButton}`]: {
        textTransform: "capitalize",
        color: theme.palette.common.white,
        backgroundColor: info,
        borderRadius: "100px",
        width: "300px",
        marginBottom: "25px",
    },
    [`& .${buyerProfileClasses.userPropertiesEmail}`]: {
        marginTop: "10px",
    },
}));
